import React from 'react'
import { sSection, s } from '../style'
import Tile from './Tile'

const Tiles = ({ data, marginMinimal, noMargin, small, large, subtitleOnTop }) => {
  return (
    <section
      css={[
        sSection,
        { [s.md]: { padding: '1rem 3rem 4rem' } },
        marginMinimal && sMarginMinimal,
        noMargin && sNoMargin,
      ]}>
      {data?.map((item, id) => (
        <Tile
          data={item}
          key={id}
          small={small}
          large={large}
          subtitleOnTop={subtitleOnTop}
        />
      ))}
    </section>
  )
}

const sMarginMinimal = {
  marginTop: '2rem',
  [s.sm_down]: {
    marginTop: '2rem',
  },
}

const sNoMargin = {
  marginTop: '0',
  [s.sm_down]: {
    marginTop: '0',
  },
}

export default Tiles
